import { cn } from '@/lib/utils'
import { Typo3Section } from '@/types/typo3'
import { Container, Richtext, Section } from '@/ui/components'
import { memo } from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  text?: string
  author?: string
  authorDescription?: string
  layout?: 'default' | 'wrapped'
  section?: Typo3Section
}

const SectionQuote = ({
  text,
  section,
  layout = 'default',
  author,
  authorDescription,
  ...props
}: Props) => {
  if (!text) {
    return null
  }

  return (
    <Section data={section} className="s-section-quote py-xl" {...props}>
      <Container
        anim="fade-in"
        size={layout === 'wrapped' ? 'sm-fixed' : undefined}
      >
        <div
          className={cn(
            'gap-gutter grid grid-cols-1 justify-between',
            layout === 'default' && 'md:grid-cols-12'
          )}
        >
          {text && (
            <Richtext
              text={'«' + text + '»'}
              className={cn(
                'h3 text-primary-300 font-medium!',
                layout === 'default' && 'md:col-span-7 lg:col-span-8'
              )}
            />
          )}
          <div
            className={cn(
              'text-neutral-400',
              layout === 'default' &&
                'md:col-span-5 lg:col-span-4 xl:col-span-3 xl:col-start-10'
            )}
          >
            {author && <p className="textstyle-md-bold">{author}</p>}
            {authorDescription && (
              <p className="textstyle-md-regular">{authorDescription}</p>
            )}
          </div>
        </div>
      </Container>
    </Section>
  )
}

SectionQuote.displayName = 'SectionQuote'

export default memo(SectionQuote)
